import { http } from './config'

export default {
    listar: () => {
        return http.get('/v1/natureza-operacao')
    },
    salvar: (data) => {
        return http.post('/v1/natureza-operacao', data)
    },
    editar: (id) => {
        return http.get(`/v1/natureza-operacao/${id}`)
    },
    atualizar: (data) => {
        return http.put(`/v1/natureza-operacao/${data.id}`, data)
    },
    excluir: (id) => {
        return http.delete(`/v1/natureza-operacao/${id}`)
    }
}